import { render, staticRenderFns } from "./yeniFis.vue?vue&type=template&id=00106f79&scoped=true&"
import script from "./yeniFis.vue?vue&type=script&lang=js&"
export * from "./yeniFis.vue?vue&type=script&lang=js&"
import style0 from "./yeniFis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./yeniFis.vue?vue&type=style&index=1&id=00106f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00106f79",
  null
  
)

export default component.exports